module.exports = __webpack_public_path__ + "static/media/default-2.3d0b352c.svg";